<template>
  <div class="alerts-filter">
    <div class="alerts-filter__label">
      {{
        $ucfirst($t("patientDocumentSearch.filter", { catalog: "app_mobile" }))
      }}
    </div>
    <div>
      <v-btn-toggle v-model="filter" multiple class="alerts-filter__toggle">
        <v-btn value="red" outlined x-large>
          <v-icon left color="red">
            {{ filter.includes("red") ? "mdi-bell" : "mdi-bell-off" }}
          </v-icon>
          {{ $ucfirst($t("alerts.red")) }}{{ getAlertCount("red") }}
        </v-btn>
        <v-btn value="orange" outlined x-large>
          <v-icon left color="orange">
            {{ filter.includes("orange") ? "mdi-bell" : "mdi-bell-off" }}
          </v-icon>
          {{ $ucfirst($t("alerts.orange")) }}{{ getAlertCount("orange") }}
        </v-btn>
        <v-btn value="yellow" outlined x-large>
          <v-icon left color="yellow">
            {{ filter.includes("yellow") ? "mdi-bell" : "mdi-bell-off" }}
          </v-icon>
          {{ $ucfirst($t("alerts.yellow")) }}{{ getAlertCount("yellow") }}
        </v-btn>
      </v-btn-toggle>
      <div class="alerts-filter__toggle-right">
        <v-btn-toggle v-model="type" multiple class="alerts-filter__toggle">
          <v-btn value="active" outlined x-large>
            <v-icon left color="red">
              {{
                filter.includes("active")
                  ? "mdi-close-circle"
                  : "mdi-close-circle-outline"
              }}
            </v-icon>
            {{ $ucfirst($t("alert.open")) }}{{ getAlertCount("active") }}
          </v-btn>
          <v-btn value="handled" outlined x-large>
            <v-icon left color="green">
              {{
                filter.includes("handled")
                  ? "mdi-check-decagram"
                  : "mdi-check-decagram-outline"
              }}
            </v-icon>
            {{ $ucfirst($t("alert.handled")) }}{{ getAlertCount("handled") }}
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Component AlertsFilter.vue
 *
 * @module AlertsFilter
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.1] app/src/APP_DASHBOARD/templates/components/Alerts/AlertsFilter.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "AlertsFilter",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    alertCount: {
      type: Object,
    },
  },
  computed: {
    filter: {
      get() {
        return this.value;
      },
      set(filters) {
        this.$emit("input", filters);
      },
    },
    type: {
      get() {
        return this.value;
      },
      set(filters) {
        this.$emit("input", filters);
      },
    }
  },
  methods: {
    getAlertCount(type) {
      if (this.alertCount && this.alertCount[type] >= 0) {
        return ": " + this.alertCount[type];
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss">
.alerts-filter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .v-btn {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }

  .alerts-filter__label {
    font-weight: 400;
    line-height: 32px;
    margin-right: 24px;
  }

  .alerts-filter__toggle-right {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }
}
</style>
